import { FC, PropsWithChildren, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';

export const withRouter: FC<PropsWithChildren> = ({ children }) => (
  <BrowserRouter>
    <Suspense fallback={null}>{children}</Suspense>
  </BrowserRouter>
);
